import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const date = new Date();
const nowDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC100005_01,
  },
  {
    title: "代行者",
    keyword: "agentUserName",
    type: "selectForm",
    selectPropsList: [],
    fullWidth: false,
  },
  {
    title: "代行内容",
    keyword: "formerTaskType",
    type: "selectForm",
    selectPropsList: [],
    fullWidth: false,
  },
  {
    title: "退職者名",
    keyword: "retirementStaffName",
    type: "nodeInLine",
    showLine: false,
  },
  {
    title: "対象施設",
    keyword: "agentFacilityName",
    type: "selectForm",
    selectPropsList: [],
    fullWidth: false,
  },
  {
    title: "タイトル",
    keyword: "requestTitle",
    type: "textarea",
    inputProps: { maxLength: 85 },
  },
  {
    title: "対応期日",
    keyword: "dueDate",
    type: "date",
    minDate: nowDate,
    maxDate: new Date("2099/12/31"),
  },
  {
    title: "本文",
    keyword: "requestContent",
    type: "textarea",
    inputProps: { maxLength: 1000 },
  },
];

const schema = {
  agentUserName: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  formerTaskType: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  requestTitle: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  dueDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  requestContent: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 1000,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "1,000"),
    },
  },
  stateSchema: {
    agentFacilityName: {
      required: TkPropertyMessageGet("TKMSG_SCR0044E"),
    },
  },
};

export { fakeTableList, schema };
